import {
  GET_ADOPTION_ASYNC,
  GET_BRIEFING_ASYNC,
  GET_DASHBOARD_ASYNC,
  GET_DMARC_ASYNC,
  GET_FEED_ASYNC,
  GET_PERFORMANCE_ASYNC,
  GET_REDIRECTS_ASYNC,
  GET_TRENDS_OVERVIEW_ASYNC,
  SET_DAYS_BACK,
  SET_PAGE_VISIBLE,
} from './constants'

const initialState = {
  daysBack: 30,
  pageVisible: true,
  dashboard: null,
  performance: null,
  dmarc: null,
  redirects: null,
  adoption: null,
  trendsOverview: null,
  briefing: null,
  feed: { items: [], cursor: null, loaded: false },
  loading: {
    dashboard: false,
    performance: false,
    dmarc: false,
    redirects: false,
    adoption: false,
    trendsOverview: false,
    briefing: false,
    feed: false,
  },
  error: {
    dashboard: null,
    performance: null,
    dmarc: null,
    redirects: null,
    adoption: null,
    trendsOverview: null,
    briefing: null,
    feed: null,
  },
}

const asyncSlice = (key, async) => (state, action) => {
  switch (action.type) {
    case async.INITIATE:
      return {
        ...state,
        loading: { ...state.loading, [key]: true },
        error: { ...state.error, [key]: null },
      }
    case async.SUCCESS:
      return {
        ...state,
        [key]: action.payload,
        loading: { ...state.loading, [key]: false },
        error: { ...state.error, [key]: null },
      }
    case async.ERROR:
      return {
        ...state,
        loading: { ...state.loading, [key]: false },
        error: { ...state.error, [key]: action.error },
      }
    case async.CANCEL:
      return { ...state, loading: { ...state.loading, [key]: false } }
    default:
      return state
  }
}

const slices = [
  ['dashboard', GET_DASHBOARD_ASYNC],
  ['performance', GET_PERFORMANCE_ASYNC],
  ['dmarc', GET_DMARC_ASYNC],
  ['redirects', GET_REDIRECTS_ASYNC],
  ['adoption', GET_ADOPTION_ASYNC],
  ['trendsOverview', GET_TRENDS_OVERVIEW_ASYNC],
  ['briefing', GET_BRIEFING_ASYNC],
].map(([key, async]) => asyncSlice(key, async))

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DAYS_BACK:
      return { ...state, daysBack: action.payload }
    case SET_PAGE_VISIBLE:
      if (state.pageVisible === action.payload) return state
      return { ...state, pageVisible: action.payload }
    case GET_FEED_ASYNC.INITIATE:
      return {
        ...state,
        loading: { ...state.loading, feed: true },
        error: { ...state.error, feed: null },
      }
    case GET_FEED_ASYNC.SUCCESS:
      return {
        ...state,
        feed: {
          items: action.payload.items || [],
          cursor: action.payload.next_cursor || null,
          loaded: true,
        },
        loading: { ...state.loading, feed: false },
        error: { ...state.error, feed: null },
      }
    case GET_FEED_ASYNC.ERROR:
      return {
        ...state,
        feed: { ...state.feed, loaded: true },
        loading: { ...state.loading, feed: false },
        error: { ...state.error, feed: action.error },
      }
    case GET_FEED_ASYNC.CANCEL:
      return { ...state, loading: { ...state.loading, feed: false } }
    default:
      return slices.reduce((s, fn) => fn(s, action), state)
  }
}

export default reducer
